import { render, staticRenderFns } from "./CollectionSpecialLabels.vue?vue&type=template&id=a2a56194&scoped=true"
import script from "./CollectionSpecialLabels.vue?vue&type=script&lang=js"
export * from "./CollectionSpecialLabels.vue?vue&type=script&lang=js"
import style0 from "./CollectionSpecialLabels.vue?vue&type=style&index=0&id=a2a56194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a56194",
  null
  
)

export default component.exports